import axios from "axios";
import React, { useEffect, useState } from "react";
import Select from "react-select";

import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { useNavigate } from "react-router-dom";
import { getApiBaseUrl, getDriverApiBaseUrl } from "../../utils/utils";
export default function AttendanceConfig() {
  const API_URL = getDriverApiBaseUrl(); // Use Driver API for attendance configs
  const [msg, setMsg] = useState("");
  const [errormsg, setError] = useState("");

  pdfMake.vfs = pdfFonts.vfs;

  const buttonsyle = {
    background: "#00a6ed",
    color: "#fff",
    padding: "3px",
    marginRight: "10px",
    borderColor: "#00a6ed",
    cursor: "pointer",
    marginTop: "3%",
    float: "right",
  };

  const [datechosenfrom, setdatechosenfrom] = useState();
  const [datechosento, setdatechosento] = useState();
  const [data, setData] = useState(null);

  useEffect(() => {
    getDetails();
  }, []);

  const [partners, setPartners] = useState([]);
  useEffect(() => {
    const fetchPartners = async () => {
      const baseApiUrl = getApiBaseUrl();
      try {
        const response = await axios.get(
          `${baseApiUrl}/v1.0/partner/retrieve_list?page=0`
        );
        setPartners(response.data.data || []);
      } catch (err) {
        setError(err.message || "Error fetching data");
      } finally {
        // setLoading(false);
      }
    };

    fetchPartners();
  }, []);

  const navigate = useNavigate();

  const handleEdit = (partnerId) => {
    console.log("Editing partner:", partnerId);
    navigate("/orders/attendance-setting/editattendance", {
      state: {
        partnerId: partnerId,
      },
    });
  };

  async function getDetails() {
    try {
      const driverApiUrl = getDriverApiBaseUrl();
      const url = `${driverApiUrl}/shypvdriverapp/attendance-config/all?page=0&size=20`;

      const response = await axios.get(url, {});

      if (response.data.success) {
        const content = response.data.data.content;

        // Use a Map to group by partnerId (or by unique config)
        const grouped = new Map();

        content.forEach((item) => {
          const key = item.partnerId; // you can add more keys if needed

          if (!grouped.has(key)) {
            grouped.set(key, {
              partnerId: item.partnerId,
              drivers: [item.driver?.name || "N/A"],
              driverMobiles: [item.driver?.mobileNumber || "-"],
              requireAttendance: item.requireAttendance,
              allowLogoutAnywhere: item.allowLogoutAnywhere,
              enableGeoRestriction: item.enableGeoRestriction,
              checkinWarehouses: item.checkinWarehouses.map((w) => w.name),
              checkoutWarehouses: item.checkoutWarehouses.map((w) => w.name),
            });
          } else {
            // append driver to existing config
            const existing = grouped.get(key);
            existing.drivers.push(item.driver?.name || "N/A");
            existing.driverMobiles.push(item.driver?.mobileNumber || "-");
          }
        });

        const formattedData = Array.from(grouped.values()).map((g) => ({
          partnerId: g.partnerId,
          drivers: g.drivers.join(", "),
          driverMobiles: g.driverMobiles.join(", "),
          requireAttendance: g.requireAttendance,
          allowLogoutAnywhere: g.allowLogoutAnywhere,
          enableGeoRestriction: g.enableGeoRestriction,
          checkinWarehouses: g.checkinWarehouses.join(", "),
          checkoutWarehouses: g.checkoutWarehouses.join(", "),
        }));

        console.log("Grouped Data:", formattedData);
        setData(formattedData);
      }

      console.log("Response:", response.data);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    }
  }

  const columns = [
    {
      name: "ID",
      selector: (row, index) => index + 1, // Auto-increment ID
      sortable: false, // Usually no need to sort by index
      width: "70px", // Optional: set a fixed width
    },
    {
      name: "Partner ID",
      selector: (row) => {
        const partner = partners.find((p) => p.pid === row.partnerId);
        return partner ? partner.pname : "Unknown";
      },
      sortable: true,
    },
    {
      name: "Drivers",
      selector: (row) => row.drivers,
      sortable: true,
      cell: (row) => (
        <div
          style={{
            width: "800px",
            wordWrap: "break-word",
            whiteSpace: "normal",
            textAlign: "left",
          }}
        >
          {row.drivers}
        </div>
      ),
    },
    {
      name: "Require Attendance",
      selector: (row) => (row.requireAttendance ? "Yes" : "No"),
      sortable: true,
    },
    {
      name: "Logout Anywhere?",
      selector: (row) => (row.allowLogoutAnywhere ? "Yes" : "No"),
      sortable: true,
    },
    {
      name: "Geo Restriction?",
      selector: (row) => (row.enableGeoRestriction ? "Yes" : "No"),
      sortable: true,
    },
    {
      name: "Selected Warehouses",
      selector: (row) => row.checkinWarehouses,
      sortable: true,
      cell: (row) => (
        <div
          style={{
            width: "300px",
            wordWrap: "break-word",
            whiteSpace: "normal",
            textAlign: "left",
          }}
        >
          {row.checkinWarehouses}
        </div>
      ),
      wrap: true,
    },
    // {
    //   name: 'Check-out Warehouses',
    //   selector: row => row.checkoutWarehouses,
    //   sortable: true,
    //    cell: (row) => (
    //       <div style={{ width: '300px', wordWrap: 'break-word', whiteSpace: 'normal', textAlign: 'left' }}>
    //         {row.checkoutWarehouses}
    //       </div>
    //     ),
    //   wrap: true,
    // },
    {
      name: "Actions",
      cell: (row) => (
        <button
          onClick={() => handleEdit(row.partnerId)}
          style={{
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            padding: "6px 12px",
            cursor: "pointer",
          }}
        >
          Edit
        </button>
      ),
      ignoreRowClick: true, // Prevents triggering row selection when clicking the button
      allowOverflow: true, // Ensures the button isn’t clipped
      button: true, // Marks this as a button column
    },
  ];

  const tableData = {
    columns,
    data,
  };

  return (
    <div>
      <div className="form-container">
        <div className="row">
          <div className="col-md-6">
            <h5 style={{ float: "left" }}>Attendance Partner Settings </h5>
          </div>
        </div>

        <div className="row">
          <div className="col-md-11">
            {data && data.length > 0 ? (
              <>
                <DataTableExtensions {...tableData}>
                  <DataTable
                    noHeader
                    defaultSortField="partnerId"
                    pagination
                    highlightOnHover
                    striped
                    responsive
                  />
                </DataTableExtensions>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
